import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import cx from 'classnames';
import RadioInput from 'wonderbly-components/lib/RadioInput';
import RichText from '../../../Prismic/RichText';
import FieldError from '../FieldError';
import Loading from '../../../Loading';
import { trackSelectedShippingMethod } from '../../../../../analytics/category/checkout';
import './ShippingMethodsField.scss';

const onUpdateShippingMethods = (props) => (event) => {
  const translatedError = get(`props.model.prismicGlobalContentModel.error.checkout.shippingMethods`, null);
  props.updateShippingMethods(
    event.target.value,
    translatedError);
  props.handleChange(event);
  const value = event.target.attributes.data.value;
  trackSelectedShippingMethod(event.target.id, value);
};


const ShippingMethodsField = (props) => {
  if (props.isLoading) {
    return <Loading dark relative small />;
  }
  return (
    <div className={`field-container--shipping shipping-methods`} key={`${props.field.type}-${props.index}`}>
      {props.field.options.map(option => {
        const isChecked = parseInt(props.values.selectedShippingRateId, 10) === option.id;
        return (
          <div
            className={cx('shipping-method', {
              'shipping-method--is-checked': isChecked,
            })}
            key={option.id}>
            <RadioInput
              id={option.id}
              value={option.id}
              name="selectedShippingRateId"
              data={option.label}
              checked={isChecked}
              onChange={onUpdateShippingMethods(props)}
              className="form-check-input"
              label={
                <div className="option-wrapper">
                  <span className="shipping-method-label">{option.label}</span>
                  <div className="shipping-price">
                    {option.cost.formatted}
                  </div>
                  <div className="field-description">
                    <RichText fields={option.description} key={`${props.field.type}-${props.index}`} />
                  </div>
                </div>
              }
            />
            {props.errors &&
              <FieldError
                errors={props.errors}
                field={props.field}
                message={props.errors[props.field.type]}
                visible={props.errors[props.field.type]}
              />
            }
          </div>
        );
      })}
    </div>
  );
};

ShippingMethodsField.propTypes = {
  index: PropTypes.number,
  isLoading: PropTypes.bool,
  field: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
  values: PropTypes.shape({
    selectedShippingRateId: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  }).isRequired,
  errors: PropTypes.object,
  updateShippingMethods: PropTypes.func,
};

export default ShippingMethodsField;



// WEBPACK FOOTER //
// ./src/client/js/view/components/UserForm/Field/ShippingMethodsField/ShippingMethodsField.js